import { render, staticRenderFns } from "./StockTab.vue?vue&type=template&id=4245bd86&"
import script from "./StockTab.vue?vue&type=script&lang=js&"
export * from "./StockTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4245bd86')) {
      api.createRecord('4245bd86', component.options)
    } else {
      api.reload('4245bd86', component.options)
    }
    module.hot.accept("./StockTab.vue?vue&type=template&id=4245bd86&", function () {
      api.rerender('4245bd86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/places/tabs/StockTab.vue"
export default component.exports